import { faUser } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/pro-solid-svg-icons'

import {
  Box, ListItem, StatusBadge, Text,
} from '@domain-group/suit-theme'

import useOrderItem from '@hooks/useOrderItem'

import { combineAgentNames } from '@functions/agent'
import { statusColors } from '@functions/status'

import type { OrderItemModel } from '@models/types'

import { EntitiesState } from '@redux/entities'

interface SignboardListItemProps {
  agents: EntitiesState['agents'],
  isPriorty: boolean,
  orderItem: OrderItemModel,
}

const SignboardListItem = (props: SignboardListItemProps) => {
  const {
    agents,
    isPriorty,
    orderItem: initOrderItem,
  } = props

  const orderItemPayload = useOrderItem(initOrderItem)

  const {
    callbacks: {
      manageTasks,
    },
    orderItem: {
      agent_ids,
      title,
    },
    campaign: {
      address, suburb_name,
    },
    status,
  } = orderItemPayload

  return (
    <ListItem
      boxProps={{
        alignItems: 'center',
        borderBottom: '1px dashed',
        padding: 'large',
      }}
      onClick={() => manageTasks()}
      showAngleIcon
    >
      <Box flexDirection="column">
        <Text fontSize="small">
          {isPriorty && (
            <Text
              color="blue"
              display="inline-block"
              fontSize="xsmall"
              marginRight="small"
              verticalAlign="top"
            >
              <FontAwesomeIcon icon={faStar} style={{ marginRight: 'small' }} />
            </Text>
          )}

          {address ? `${address}, ${suburb_name}` : 'No Campaign'}
        </Text>

        <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="large">
          <FontAwesomeIcon icon={faUser} /> {combineAgentNames({ agentIds: agent_ids, agents, joiningWord: '&' })}
        </Text>
      </Box>

      <Box alignItems="flex-end" flexDirection="column" justifyContent="center" marginLeft="auto" width="auto">
        <Text fontSize="small" display={['none', 'inline-block']} style={{ whiteSpace: 'nowrap' }}>
          {title}
        </Text>

        <StatusBadge
          boxProps={{ display: 'end', marginTop: [0, 'medium'] }}
          // @ts-expect-error TS2538
          color={statusColors[status.key]}
          ghost
          text={status.title}
        />
      </Box>
    </ListItem>
  )
}

export default SignboardListItem
